import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Device from './../../devices/device';
import Utils from './../../utils/Utils';
import store from '../../store'
import { setDataPinCodes } from '../../actions/pinCodes'
import channelBlockedUtil from "../../utils/ChannelBlockedUtil";

/**
 * Default values for metadata keys
 */
const defaultIntervalTimeSeconds = 600;
const defaultChannelCriticalRating = 10;

const metadataKey = 'pin_use_channel_rating_flow';

/**
 * Campos de la llave, por región:
 *  enable: true / false
 *          Para habilitar o no el flujo para revisar canales críticos
 *
 *  enable_pin_request: true / false
 *          Si el valor de enable (arriba) esta a true, entonces este valor indica si hace una llamada del pin después de cada cambio de live canal
 *
 *  interval: n segundos
 *           Si el valor de enable (arriba) esta a true, este valor indica cada cuántos segundos se llama al statuscontrolpin en el background/asíncrono
 *
 *  critical_rating_value: number ¿?
 *          Si el valor de enable (arriba) esta a true, este valor indica el valor mínimo/igual para definir si un canal es crítico o no
 */
const metadataDefaultValue = '{"enable":false, "enable_pin_request": false, "interval": ' + defaultIntervalTimeSeconds + ', "critical_rating_value": ' + defaultChannelCriticalRating + '}';

/**
 * Para saber si usamos el flujo del channelRating
 * enable true or false
 */
const getMedatataValue = function (key, defaultValue) {
    return Utils.getApaMetadataKey(key, defaultValue);
};

/**
 * Para saber si usamos el flujo del channelRating
 * enable true or false
 */
const useChannelRatingFlow = function () {

    let _useChannelRatingFlow = Utils.getApaMetadataKey(metadataKey, metadataDefaultValue, 'enable')
    let subplatform = null;
    // TODO Se cierra por device también ¿? a que sea sólo android?
    if (_useChannelRatingFlow) {
        if (Utils.isFunction(Device.getDevice().getSubplatform)) {
            subplatform = Device.getDevice().getSubplatform();
        }

        if (!subplatform) {
            _useChannelRatingFlow = false;
        }
        else {
            switch (subplatform) {
                case 'stbkaon':
                case 'stbhuawei':
                case 'zte':
                    // Se mantiene para kaon y huawei
                    break;
                default:
                    _useChannelRatingFlow = false;
                    break;
            }
        }

    }

    //console.log('[AAF_FWK2] AAF Pin useChannelRatingFlow > ' + (_useChannelRatingFlow ? 'TRUE' : 'FALSE') + ' <> ' + subplatform);

    return _useChannelRatingFlow;
};

/**
 * Si usamos el flujo del channelRating, hacemos o no el pin request?
 */
const usePinRequest = function () {
    let _usePinRequest = false;
    if (useChannelRatingFlow()) {
        const useChannelRatingFlowKey = getMedatataValue(metadataKey, metadataDefaultValue);
        if (useChannelRatingFlowKey ) {
            _usePinRequest = useChannelRatingFlowKey.enable_pin_request;
        }
    }

    return _usePinRequest;
};

/**
 * Para definir el timeout de la llamada/interval para actualizar status control pin
 * return en segundos
 */
const getIntervalSecondsForBlockedChannels = function () {
    return Utils.getApaMetadataKey(metadataKey, metadataDefaultValue) ? Utils.getApaMetadataKey(metadataKey, metadataDefaultValue).interval : defaultIntervalTimeSeconds;
};

/**
 * Para definir el timeout de la llamada/interval para actualizar status control pin
 * return en segundos
 */
const getCriticalChannelRating = function () {
    const region = DeviceStorage.getItem("region");
    const _intervalSecondsKey = getMedatataValue(metadataKey, metadataDefaultValue);
    let _defaultChannelCriticalRating = defaultChannelCriticalRating;
    if (_intervalSecondsKey) {
        _defaultChannelCriticalRating = _intervalSecondsKey.critical_rating_value;
    }
    return _defaultChannelCriticalRating;
};

export const updateBlockedChannelsList = (toBlock, groupId) => {
  const {pin_channel} = store.getState().pinCodes
  const channelList = pin_channel.info ? pin_channel.info : []; // channelBlockedUtil.get('blockedChannels');
  if(channelList && Array.isArray(channelList)){
    if (toBlock) {
      channelList.push(groupId);
    } else {
      const index = channelList.indexOf(groupId);
      channelList.splice(index, 1);
    }
    channelBlockedUtil.clear();
    channelBlockedUtil.set('blockedChannels', channelList);
    if(pin_channel){
      let auxPinChannel;
      if(pin_channel.status) auxPinChannel = {pin_channel : { status : 1, info : channelList } }
      store.dispatch(setDataPinCodes(auxPinChannel))
    }
  }
}

const updateBlockedChannels = (dataKey, blockedChannels) => {
  blockedChannels = dataKey.status === 1 ? dataKey.info : [];
  channelBlockedUtil.set('blockedChannels', blockedChannels);
}

const updateStatePinCodes = (response, dataStore, blockedChannels) => {
  if(response){
    const dataKey = response.pin_channel ? response.pin_channel : dataStore.pin_channel
    const updateStore = response
    store.dispatch(setDataPinCodes(updateStore))
    updateBlockedChannels(dataKey, blockedChannels)
  }else{
    const dataKey = dataStore.pin_channel
    const updateStore = dataStore
    store.dispatch(setDataPinCodes(updateStore))
    updateBlockedChannels(dataKey, blockedChannels)
  }
}

export const handleDataPinCodesSuccess = (resp, blockedChannels) => {
  const dataStore = store.getState().pinCodes
  const {response = null} = resp || {};

  updateStatePinCodes(response, dataStore, blockedChannels)
}

export const handleDataPinCodesError = (blockedChannels) => {
  const {pin_channel} = store.getState().pinCodes
  updateBlockedChannels(pin_channel, blockedChannels)
}

/**
 * Export module
 */
const PinUtil = {
  useChannelRatingFlow: useChannelRatingFlow,
  usePinRequest: usePinRequest,
  getIntervalSecondsForBlockedChannels: getIntervalSecondsForBlockedChannels,
  getCriticalChannelRating: getCriticalChannelRating,
  updateBlockedChannelsList,
  updateBlockedChannels,
  updateStatePinCodes,
  handleDataPinCodesSuccess,
  handleDataPinCodesError,
};

export { PinUtil };



// WEBPACK FOOTER //
// ./src/AAF/Pin/PinUtil.js